<template>
  <div class="acs-container">
    <h1 class="page-title">brand follow up</h1>

    <ErrorBanner />

    <loading-icon v-if="isLoading" />

    <sb-table v-else-if="hasACs" :columns="columns" :rows="rows">
      <template #cell="{ row, column }">
        <div v-if="column.key === 'view'" :class="column.key">
          <router-link :to="`/autoconnects/${row.id}`" class="link">
            view
          </router-link>
        </div>
        <div
          v-else
          :class="[column.key, column.key === 'status' ? row[column.key] : '']"
        >
          {{ row[column.key] }}
        </div>
      </template>
    </sb-table>

    <div v-else-if="!hasACs">no autoconnects to display</div>

    <pagination
      v-if="!isLoading && totalPages > 1"
      :currentPage="currentPage"
      :totalPageCount="totalPages"
      showArrows
      @changePage="getACs"
    />
  </div>
</template>

<script>
import LoadingIcon from '../Shared/LoadingIcon.vue'
import Pagination from '../Shared/Pagination.vue'
import { autoCampaignAPI } from '../../services/api/autoCampaignAPI'
import { calculateTotalPagesUtil } from '../../utilities'
import { ErrorBanner, UnexpectedError } from '@springbig/sb-components'

export default {
  props: {
    currentAdvertiser: Object,
  },

  name: 'AutoCampaigns',

  components: {
    ErrorBanner,
    LoadingIcon,
    Pagination,
  },

  data() {
    return {
      isLoading: false,
      columns: [
        { label: 'merchants', key: 'merchants' },
        { label: 'textable members (updated daily)', key: 'textable' },
        { label: 'status', key: 'status' },
        { label: '', key: 'view' },
      ],
      totalPages: null,
      currentPage: null,
      rows: null,
    }
  },

  created() {
    this.getACs()
  },

  computed: {
    hasACs() {
      return this.rows?.length > 0
    }
  },

  methods: {
    async getACs(currentPage = 1) {
      try {
        this.isLoading = true
        this.currentPage = currentPage
        this.$store.dispatch('DISMISS_ERRORS', { type: UnexpectedError })

        const data = await autoCampaignAPI.getAutoCampaigns(
          this.currentAdvertiser.id,
          this.currentPage
        )
        this.totalPages = calculateTotalPagesUtil(
          data.pagination.total_elements,
          data.pagination.per_page
        )
        this.configureTableData(data.brand_follow_up_auto_campaigns)
      } catch (e) {
        this.$store.dispatch('ADD_ERROR', new UnexpectedError(e))
      } finally {
        this.isLoading = false
      }
    },

    configureTableData(acData) {
      this.rows = acData.map((ac) => ({
        merchants: ac.merchant_name,
        textable: ac.textable_members,
        status: ac.enabled ? 'on' : 'off',
        id: ac.id,
      }))
    },
  },
}
</script>

<style lang="sass">
@import '../../assets/sass/colors'

.acs-container
  text-align: center
  padding: 2rem 2rem 0

  .page-title
    margin-bottom: 2rem

  .sb-table
    margin: 1em auto
    min-height: 0
    min-width: 0
    width: 70%
    @media only screen and (max-width: 425px)
      width: 100%
    .grid-header, .grid-content
      // Need !important to override direct style injection from component in vue-components
      grid-template-columns: 3fr 2fr 2fr 1fr !important
      div
        min-width: 0
        word-break: break-all
    .grid-header
      font-weight: bold
      margin-bottom: 1rem
      padding: 0 .5em
      div:first-child
        text-align: left
    .grid-content
      padding: .5em
      &:nth-child(even)
        background-color: $active-primary-background
      .merchants
        text-align: left
        word-break: break-all
      .status.off
        color: $negative-hover
      .status.on
        color: $active-status
</style>
